import React from 'react'
import PropTypes from 'prop-types'
import { Stack, Box, Text, Link, Heading } from '@rebeldotcom/components'

const propTypes = {
  menu: PropTypes.shape({
    heading: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        label: PropTypes.string,
        path: PropTypes.string,
      })
    ),
  }).isRequired,
  menuStyle: PropTypes.shape({
    headingVariant: PropTypes.string.isRequired,
    itemVariant: PropTypes.string.isRequired,
  }).isRequired,
}

const VerticalMenu = ({ menu, menuStyle, ...rest }) => {
  return (
    <Stack {...rest}>
      <Heading my={3} variant={menuStyle.headingVariant}>
        {menu.heading}
      </Heading>
      <Stack as="ul" gridGap={2}>
        {menu.items.map(item => {
          return (
            <Box key={item.id} as="li">
              <Link color="black" href={item.url} id={item.id}>
                <Text
                  textTransform="capitalize"
                  variant={menuStyle.itemVariant}
                >
                  {item.label}
                </Text>
              </Link>
            </Box>
          )
        })}
      </Stack>
    </Stack>
  )
}

VerticalMenu.propTypes = propTypes

export { VerticalMenu }
